import { flow, getEnv, resolveIdentifier,destroy, types} from "mobx-state-tree";
import {MediaFile} from "../../models/mediaFiles/MediaFileModel";
import {TagModel} from "../../models/tags/TagModel";
import {Utm} from "../../models/utms/UtmModel";

const MediaFileStore = types.model('MediaFileStore',{
    storeUuid: types.identifier,
    list: types.optional(types.array(MediaFile), []),
    flatList: types.optional(types.array(types.frozen()), []),
    //isLoading..
}).volatile((self)=>({
  filterListOn:types.fn,
})).actions((self)=>({
  setFilterOn(groupUuid) {
    self.filterListOn = (item) => {   //function used to filter utm options by selected group
      return (item?.owner?.groupUuid === groupUuid || item?.isExclusivelyGroupOwned === false)
    }
  },
  addFileToList(file){
    const index = self.list.findIndex((item) => item.uuid === file.uuid);
    if (index !== -1) {
      return
    }
    self.list.push( MediaFile.create({
      uuid: file.uuid,
      name: file.name,
      label: file.name,
      status: file.status,
      singleUseFile: file.singleUseFile,
      usage: file.usage === "qrImage" ? "qrImage" :"content",
      fileFormat: file.fileFormat,
      liveLinks: file.liveLinks? file.liveLinks : [],
      _audit: file?._audit,
      createdAt: file?.createdAt,
      updatedAt: file?.updatedAt,
      isExclusivelyGroupOwned: file?.isExclusivelyGroupOwned,
      owner: file?.owner
    }))

  },
  removeSingleUseFilesFromList(params){
    self.getMediaFiles(params) // this will remove any single use file from the list
    // for some reason the file is not removed from the tree using a filter or other methods like detach()
  },
  initWithData(items = []) {
    try {
      if (items) {
        self.list = items.map(file => {
          let nestedTags = [];
            if(file.tags && file.tags.length > 0){
              nestedTags = file.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
            }

            return MediaFile.create({
              uuid: file.uuid,
              name: file.name,
              status: file.status,
              label: file.name,
              singleUseFile: file.singleUseFile,
              usage: file.usage === "qrImage" ? "qrImage" :"content",
              fileFormat: file.fileFormat,
              liveLinks: file.liveLinks? file.liveLinks : [],
              _audit: file?._audit,
              createdAt: file?.createdAt,
              updatedAt: file?.updatedAt,
              isExclusivelyGroupOwned: file?.isExclusivelyGroupOwned,
              tags: nestedTags,
              owner: file?.owner,
            })
          },
        )
        self.list.sort((a, b) => a.label.localeCompare(b.label))
        // self.list = self.list.filter(file => file.singleUseFile === false)
      }
    } catch (e) {
      console.error("Failed to init media files with data", e);
    }
  },
    // initWithData(items = []) {
    //     try {
    //         self.list = items.map(item =>
    //             MediaFile.create({
    //                 uuid: item.uuid,
    //                 name: item.name,
    //                 label: item.name,
    //                 usage: item.usage === "qrImage" ? "Qr Image" :"Content",
    //                 fileFormat: item.fileFormat,
    //                 mediaType: item.mediaType,
    //                 _audit: item?._audit,
    //                 createdAt: item?.createdAt,
    //                 updatedAt: item?.updatedAt,
    //                 //todo complete object
    //
    //             })
    //         );
    //     } catch (e) {
    //         console.error("Failed to init mediaFiles with data", e);
    //     }
    // },
  init: flow(function* f(params = {}) {
    const resp = yield self.getMediaFiles(params);
    if(!resp) {
      return;
    }
    self.setMediaFiles(resp.results)
  }),
    // init: flow(function* f(params = {}) {
    //     console.log("load mediaFileStore from API");
    //     const resp = yield self.getMediaFiles(params);
    //     console.log(resp);
    //     self.list = resp.results.map(el => MediaFile.create({ ...el}))
    // }),
    getMediaFiles: flow(function* getMediaFiles(params = {}) {
        try {
            const resp = yield getEnv(self).mediaFileManager.fetchAll(params);
          self.initWithData(resp.results)
        } catch (error) {
        console.error("Failed to fetch publish MediaFiles", error);
        }
    }),
  getMediaFile: flow(function* getMediaFile(uuid) {
    try {
      return yield getEnv(self).mediaFileManager.getMediaFile(uuid);
    } catch (error) {
      console.error("Failed to fetch mediaFile", error);
    }

  } ),
  updateMediaFile(mediaFile) {
    const index = self.list.findIndex((item) => item.uuid === mediaFile.uuid);
    if (index !== -1) {
      self.list[index].updateMediaFile(mediaFile);
      //select the updated mediaFile
    }
  },
  removeFileByUuid(uuid) {
    const index = self.list.findIndex(file => file.uuid === uuid);
    if (index !== -1) {
      destroy(self.list[index]); // this ensures the node is removed cleanly
    }
  },

  setMediaFiles(MediaFiles) {
    if (MediaFiles) {
      const flatList = MediaFiles.map(file => {
      let nestedTags = [];
          if(file.tags && file.tags.length > 0){
            nestedTags = file.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
          }
          return {
            uuid: file.uuid,
            name: file.name,
            label: file.name,
            status: file.status,
            singleUseFile: file.singleUseFile,
            usage: file.usage === "qrImage" ? "qrImage" :"content",
            fileFormat: file.fileFormat,
            mediaType: file.mediaType,
            _audit: file?._audit,
            createdAt: file?.createdAt,
            updatedAt: file?.updatedAt,
            liveLinks: file.liveLinks? file.liveLinks : [],
            isExclusivelyGroupOwned: file?.isExclusivelyGroupOwned,
            tags: nestedTags,
            // owner: file?.owner,
            isEditable: file?.isEditable
          }
        },
      ).filter(file => file.singleUseFile !== true)

      self.flatList = flatList
    }
  },
    // setMediaFiles(items){
    //
    //   self.list = items.map(item =>
    //       MediaFile.create({
    //         uuid: item.uuid,
    //         name: item.name,
    //         label: item.name,
    //         usage: item.usage === "qrImage" ? "Qr Image" :"Content",
    //         fileFormat: item.fileFormat,
    //         mediaType: item.mediaType,
    //         _audit: item?._audit,
    //         createdAt: item?.createdAt,
    //         updatedAt: item?.updatedAt,
    //             //TODO: finish object
    //         })
    //     )
    // },
    searchFor(txt){
        //TODO: search for groups with name like 'txt'
    }


})).views((self) => ({

  filteredList() {
    return self.flatList.filter((item) => self.filterListOn(item))
  }
}));



export default MediaFileStore;
